import React from 'react';
import { Dialog, DialogContent, DialogTitle, DialogHeader } from '@/components/ui/dialog';
import { ScrollArea } from '@/components/ui/scroll-area';
import { useAssetAnalysisData, useAssetAnalysisFormat } from './hooks';
import {
  SkeletonDashboard,
  AssetOverviewCard,
  AssetAllocationChart,
  TopPerformersList
} from './components';

interface AssetAnalysisListDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  followUserId: string;
  fetchData?: (followUserId?: string) => Promise<any[]>;
}

const AssetAnalysisListDialog: React.FC<AssetAnalysisListDialogProps> = ({
  open,
  onOpenChange,
  followUserId,
  fetchData
}) => {
  // 数据获取和状态管理
  const { analysisData, loading } = useAssetAnalysisData({
    open,
    followUserId,
    fetchData
  });

  // 格式化工具
  const { formatAmount, formatReturnRate, getPieData } = useAssetAnalysisFormat();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-h-[80vh] max-w-4xl overflow-hidden bg-white">
        <DialogHeader className="flex flex-row items-center justify-between">
          <DialogTitle className="text-xl font-semibold text-gray-900">总资产详情分析</DialogTitle>
        </DialogHeader>

        {/* 内容区域 */}
        <div className="space-y-4">
          {loading ? (
            <SkeletonDashboard />
          ) : analysisData.length === 0 ? (
            <div className="py-8 text-center text-gray-500">暂无资产分析数据</div>
          ) : (
            <ScrollArea className="h-[70vh]">
              {analysisData.map(analysis => (
                <div
                  key={analysis.id}
                  className="mb-6 rounded-lg bg-gradient-to-br from-[#EEEDFF] to-[#F6F7FF] p-6"
                >
                  {/* 总资产概览 */}
                  <AssetOverviewCard
                    analysis={analysis}
                    formatAmount={formatAmount}
                    formatReturnRate={formatReturnRate}
                  />

                  {/* 资产配置分析和收益贡献排行 */}
                  <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
                    {/* 资产配置分析 */}
                    <AssetAllocationChart pieData={getPieData(analysis.assetAllocation)} />

                    {/* 收益贡献排行 TOP3 */}
                    <TopPerformersList
                      performers={analysis.topPerformers}
                      formatAmount={formatAmount}
                      formatReturnRate={formatReturnRate}
                    />
                  </div>
                </div>
              ))}
            </ScrollArea>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default AssetAnalysisListDialog;
